// eslint-disable-next-line no-shadow
enum EViewDataStatus {
    OK = 'OK',
    LimitExceeded = 'LimitExceeded',
    LimitReached = 'LimitReached',
}

export default EViewDataStatus
